import React, { useEffect, useState } from 'react';
import { Save, Trash2, Eye, X, Calendar, User, FileText, AlertCircle, Clock, CheckCircle } from 'lucide-react';
import moment from 'moment';
import { uploadPurchaseDocument, listPurchaseDocument, deletePurchaseDocument } from '@/redux/Purchase/actions';
import DateInputwithcal from '../ui/DateInputwithcal';
import { useDispatch, useSelector } from "react-redux";
import CelebrationButton from '../ui/CelebrationButton/CelebrationButton';
import { showToast } from '@/redux/Toast/actions';


const UploadNotes = ({ BookingID, RefNumber, type }) => {
    const [noteType, setNoteType] = useState('');
    const [contactPerson, setContactPerson] = useState('');
    const [noteStatus, setNoteStatus] = useState('');
    const [internalNotes, setInternalNotes] = useState('');
    const [reminderDate, setReminderDate] = useState('');
    const [notesList, setNotesList] = useState([]);
    const [selectedNote, setSelectedNote] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dateErrors, setDateErrors] = useState({});
    const [formData, setFormData] = useState({});

    const { salesPersonList, notesTypeList } = useSelector((state) => state.common);
    const { isAnimate } = useSelector((state) => state.toast);
    const dispatch = useDispatch();

    console.log('notesTypeList', notesTypeList);
    const [authUser] = JSON.parse(localStorage.getItem('authUser') ?? "[{}]");
    const userName = authUser?.username;
    const companyId = authUser?.companyId;
    // API endpoints based on type
    const url = {
        Booking: {
            list: 'v1/Booking/GetBookingNotes?BookingID=',
            upload: 'v1/Booking/InsertBookingNotes',
            delete: 'v1/Booking/DeleteBookingNote'
        },
        ImportBooking: {
            list: "v1/Arrival_Import/GetArrivalNoticeNotes?FileNumber=",
            upload: "v1/Arrival_Import/InsertArrivalNoticeNotes",
            delete: "v1/Arrival_Import/DeleteArrivalNoticeNotes",
        }
    }


    useEffect(() => {
        _getNotesList();
    }, [BookingID]);

    // Fetch notes list from API
    const _getNotesList = () => {
        let payload = BookingID;

        if (type === "ImportBooking") {
            payload = `${RefNumber}&CompanyID=${companyId}`;
        }

        listPurchaseDocument(url[type].list, payload).then(response => {
            console.log('Notes List:', response);
            if (response && response.statuscode === 200) {
                setNotesList(response.data || []);
            } else {
                setNotesList([]);
            }
        }).catch(error => {

            dispatch(showToast("Something went wrong while loading notes.", "error"));
        });
    }


    // { date formData handlers}
    const handleDateChange = (name, value) => {
        setReminderDate(value);
    };

    const handleDateError = (fieldName, hasError) => {
        setDateErrors(prev => ({
            ...prev,
            [fieldName]: hasError
        }));
    };


    // {end date formData handlers}

    // Save note to API
    const _saveNote = () => {

        // 🔍 Basic validations
        if (!noteType) {

            dispatch(showToast("Please select a note type.", "error"));
            return;
        }

        if (!internalNotes.trim()) {

            dispatch(showToast("Please enter notes content.", "error"));
            return;
        }

        // 📅 Date validation
        if (Object.values(dateErrors).some(Boolean)) {

            dispatch(showToast("Please correct the date fields", "error"));
            return;
        }

        // 🧾 Prepare payload
        let jsonPayload = {};

        if (type === 'Booking') {
            jsonPayload = {
                BookingID: BookingID,
                BookingRef: RefNumber,
                NotesType: noteType,
                ContactPerson: contactPerson,
                NoteStatus: noteStatus,
                Notes: internalNotes,
                SetReminder: reminderDate,
                CreatedBy: userName,
                ReadBy: "",
                ReadOn: null
            };
        }
        else if (type === "ImportBooking") {
            jsonPayload = {
                "id": 0,
                "CompanyId": companyId,
                "fileNumber": RefNumber,
                "moduleName": "ImportBooking",
                "notesType": noteType,
                "contactPerson": contactPerson,
                "noteStatus": noteStatus,
                "reminder": reminderDate ? true : false,
                "reminderDate": reminderDate ? moment(reminderDate).format('YYYY-MM-DD') : null,
                "notes": internalNotes,
                "createdBy": userName,
                "isActive": true,
                "deletedBy": "",
                "isRead": false,
                "readByUser": "",
                "readOnTime": null,
                "createdOn": new Date().toISOString()
            }
        }

        console.log('Note payload:', jsonPayload);

        // 🚀 API call
        uploadPurchaseDocument(url[type].upload, jsonPayload)
            .then(response => {
                if (response && (response.statuscode === 200 || response.statuscode === 201)) {

                    dispatch(showToast("Note added successfully.", "success", true));
                    _clearForm();
                    _getNotesList();
                } else {

                    dispatch(showToast("Failed to add note. Please try again.", "error"));
                }
            })
            .catch(error => {
                console.error(error);

                dispatch(showToast("An error occurred while adding the note.", "error"));
            });
    };


    // Delete note from API
    const _deleteNote = (noteId) => {
        if (window.confirm('Are you sure you want to delete this note?')) {
            let payload = {
                "BookingNotesId": noteId,
                "ModifiedBy": "ADMIN"
            };
            if (type === "ImportBooking") {
                payload = {
                    "id": noteId,
                    "companyId": companyId,
                    "deletedBy": userName
                }
            }
            deletePurchaseDocument(url[type].delete, payload).then(response => {
                if (response && (response.statuscode === 200 || response.statuscode === 201)) {

                    dispatch(showToast("Note deleted successfully.", "success"));
                    _getNotesList();
                } else {

                    dispatch(showToast("Failed to delete note. Please try again.", "error"));
                }
            }).catch(error => {


                dispatch(showToast("An error occurred while deleting the note.", "error"));
            });
        }
    }

    // View note details in modal
    const _viewNote = (note) => {
        setSelectedNote(note);
        setIsModalOpen(true);
    }

    // Close modal
    const _closeModal = () => {
        setIsModalOpen(false);
        setSelectedNote(null);
    }

    // Clear form fields
    const _clearForm = () => {
        setNoteType('');
        setContactPerson('');
        setNoteStatus('');
        setInternalNotes('');
        setReminderDate('');
    }

    // Get status badge styles
    const getStatusBadge = (status) => {
        const styles = {
            LOW: 'bg-green-100 text-green-800 border border-green-200',
            MEDIUM: 'bg-yellow-100 text-yellow-800 border border-yellow-200',
            HIGH: 'bg-orange-100 text-orange-800 border border-orange-200',
            CRITICAL: 'bg-red-100 text-red-800 border border-red-200'
        };
        return styles[status] || 'bg-gray-100 text-gray-800 border border-gray-200';
    }

    // Get note type icon and color
    const getNoteTypeInfo = (type) => {
        const types = {
            Accounting: { icon: '📊', color: 'text-indigo-600', bg: 'bg-indigo-50' },
            External: { icon: '🌐', color: 'text-blue-600', bg: 'bg-blue-50' },
            Internal: { icon: '🏢', color: 'text-purple-600', bg: 'bg-purple-50' },
            Other: { icon: '📝', color: 'text-gray-600', bg: 'bg-gray-50' },
            Trucking: { icon: '🚚', color: 'text-green-600', bg: 'bg-green-50' },
            "Vessel Roll Over": { icon: '🚢', color: 'text-cyan-600', bg: 'bg-cyan-50' },
        };

        return types[type] || { icon: '📝', color: 'text-gray-600', bg: 'bg-gray-50' };
    };

    return (
        <>
            {/* Add Notes Section */}
            <div className=" p-2">


                <div className="grid grid-cols-2 gap-4">
                    {/* Notes Type */}
                    <div>
                        <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                            Notes Type <span className="text-red-500">*</span>
                        </label>
                        <select
                            value={noteType}
                            onChange={(e) => setNoteType(e.target.value)}
                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                        >
                            <option value="">SELECT NOTES TYPE</option>
                            {notesTypeList?.map((type, index) => (
                                <option key={index} value={type.notesType}>{type.notesType}</option>
                            ))}
                            {/* <option value="INTERNAL">INTERNAL</option>
                            <option value="URGENT">URGENT</option>
                            <option value="FOLLOWUP">FOLLOW UP</option> */}
                        </select>
                    </div>

                    {/* Contact Person */}
                    <div>
                        <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                            To Contact Person
                        </label>
                        <select
                            value={contactPerson}
                            onChange={(e) => setContactPerson(e.target.value)}
                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                        >
                            <option value="">SELECT CONTACT PERSON</option>
                            {salesPersonList.map((person, index) => (
                                <option key={index} value={person.salesPerson}>{person.salesPerson}</option>
                            ))}
                        </select>
                    </div>

                    {/* Notes Status */}
                    <div>
                        <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                            Notes Status
                        </label>
                        <select
                            value={noteStatus}
                            onChange={(e) => setNoteStatus(e.target.value)}
                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                        >
                            <option value="">Select Status</option>
                            <option value="LOW">LOW</option>
                            <option value="MEDIUM">MEDIUM</option>
                            <option value="HIGH">HIGH</option>
                            <option value="CRITICAL">CRITICAL</option>
                        </select>
                    </div>

                    {/* Set Reminder */}
                    <div>
                        <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                            Set Reminder
                        </label>
                        <DateInputwithcal onError={handleDateError} label="Title cut off" name="reminderDate" value={reminderDate} onChange={handleDateChange} required />

                    </div>

                    {/* Internal Notes - Full width */}
                    <div className="col-span-2">
                        <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                            Internal Notes <span className="text-red-500">*</span>
                        </label>
                        <textarea
                            value={internalNotes}
                            onChange={(e) => setInternalNotes(e.target.value)}
                            rows="3"
                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                            placeholder="Enter your notes here..."
                        />
                    </div>

                    {/* Buttons */}
                    <div className="col-span-2 flex justify-end space-x-2 pt-2">
                        <button
                            onClick={_clearForm}
                            className="px-4 py-2 text-sm hover:bg-slate-200 dark:bg-slate-700 rounded-lg font-medium text-slate-700 dark:text-slate-300 hover:bg-slate-300 dark:hover:bg-slate-600 transition-all"
                        >
                            Clear
                        </button>
                        <CelebrationButton
                            label='Save'
                            onClick={_saveNote}
                            className="px-4 py-2 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-normal transition-all flex items-center"
                            icon={<Save className="w-4 h-4" />}
                            isSuccess={isAnimate}
                        />
                    </div>
                </div>
            </div>

            {/* View Notes Section */}
            <p className="text-xs font-medium text-slate-900 dark:text-white mb-3">
                View Booking Notes For File Reference Number: {RefNumber || ""}
            </p>
            <div className="mt-4 bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 p-4">


                {notesList.length === 0 ? (
                    <div className="text-center py-2">
                        <FileText className="w-12 h-12 mx-auto text-blue-300 dark:text-Blue-700 mb-2" />
                        <p className="text-sm text-slate-500 dark:text-slate-400">No notes added yet.</p>
                    </div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm text-left text-slate-900 dark:text-white">
                            <thead className="bg-slate-50 dark:bg-slate-800">
                                <tr>
                                    <th className="px-4 py-3 border-b border-slate-200 dark:border-slate-700 font-semibold">TYPE</th>
                                    <th className="px-4 py-3 border-b border-slate-200 dark:border-slate-700 font-semibold">CONTACT PERSON</th>
                                    <th className="px-4 py-3 border-b border-slate-200 dark:border-slate-700 font-semibold">NOTE</th>
                                    <th className="px-4 py-3 border-b border-slate-200 dark:border-slate-700 font-semibold">STATUS</th>
                                    <th className="px-4 py-3 border-b border-slate-200 dark:border-slate-700 font-semibold">CREATED</th>
                                    <th className="px-4 py-3 border-b border-slate-200 dark:border-slate-700 font-semibold">ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {notesList.map((note, index) => {
                                    const typeInfo = getNoteTypeInfo(note.NotesType);
                                    return (
                                        <tr key={index} className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                                            <td className="px-4 py-3 border-b border-slate-200 dark:border-slate-700">
                                                <div className="flex items-center">
                                                    <span className="text-lg mr-2">{typeInfo.icon}</span>
                                                    <span className="font-medium">{note.NotesType}</span>
                                                </div>
                                            </td>
                                            <td className="px-4 py-3 border-b border-slate-200 dark:border-slate-700">
                                                <div className="flex items-center">
                                                    <User className="w-3 h-3 mr-2 text-slate-400" />
                                                    {note.ContactPerson || '—'}
                                                </div>
                                            </td>
                                            <td className="px-4 py-3 border-b border-slate-200 dark:border-slate-700 max-w-xs">
                                                <div className="truncate" title={note.Notes}>
                                                    {note.Notes}
                                                </div>
                                            </td>
                                            <td className="px-4 py-3 border-b border-slate-200 dark:border-slate-700">
                                                <span className={`px-3 py-1 text-xs rounded-full font-medium ${getStatusBadge(note.NoteStatus)}`}>
                                                    {note.NoteStatus || '—'}
                                                </span>
                                            </td>
                                            <td className="px-4 py-3 border-b border-slate-200 dark:border-slate-700">
                                                <div className="flex flex-col">
                                                    <span className="text-xs text-slate-500 dark:text-slate-400">
                                                        {moment(note.CreatedOn).format('MMM DD, YYYY')}
                                                    </span>
                                                    <span className="text-xs text-slate-400 dark:text-slate-500">
                                                        {moment(note.CreatedOn).format('hh:mm A')}
                                                    </span>
                                                </div>
                                            </td>
                                            <td className="px-4 py-3 border-b border-slate-200 dark:border-slate-700">
                                                <div className="flex items-center space-x-2">
                                                    <button
                                                        className="p-2 text-slate-600 hover:text-blue-600 dark:text-slate-400 dark:hover:text-blue-400 transition-colors rounded hover:bg-blue-50 dark:hover:bg-blue-900/20"
                                                        title="View Details"
                                                        onClick={() => _viewNote(note)}
                                                    >
                                                        <Eye className="w-4 h-4" />
                                                    </button>
                                                    <button
                                                        className="p-2 text-slate-600 hover:text-red-600 dark:text-slate-400 dark:hover:text-red-400 transition-colors rounded hover:bg-red-50 dark:hover:bg-red-900/20"
                                                        title="Delete"
                                                        onClick={() => _deleteNote(note?.BookingNotesId)}
                                                    >
                                                        <Trash2 className="w-4 h-4" />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Note Detail Modal */}
            {isModalOpen && selectedNote && (
                <div className="fixed inset-0 z-50 overflow-y-auto">
                    <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                        {/* Background overlay */}
                        <div
                            className="fixed inset-0 transition-opacity bg-black bg-opacity-50"
                            onClick={_closeModal}
                        ></div>

                        {/* Modal panel */}
                        <div className="inline-block w-full max-w-2xl my-8 overflow-hidden text-left align-middle transition-all transform bg-white dark:bg-slate-900 rounded-xl shadow-xl">
                            {/* Modal header */}
                            <div className="px-6 py-4 border-b border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/50">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-3">
                                        <div className={`p-2 rounded-lg ${getNoteTypeInfo(selectedNote.NotesType).bg}`}>
                                            <span className="text-2xl">{getNoteTypeInfo(selectedNote.NotesType).icon}</span>
                                        </div>
                                        <div>
                                            <h3 className="text-lg font-semibold text-slate-900 dark:text-white">
                                                Note Details
                                            </h3>
                                            <p className="text-sm text-slate-500 dark:text-slate-400">
                                                Booking Ref: {RefNumber || selectedNote.BookingRef}
                                            </p>
                                        </div>
                                    </div>
                                    <button
                                        onClick={_closeModal}
                                        className="p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
                                    >
                                        <X className="w-5 h-5" />
                                    </button>
                                </div>
                            </div>

                            {/* Modal body */}
                            <div className="px-6 py-4">
                                <div className="space-y-6">
                                    {/* Note Type and Status */}
                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide mb-1">
                                                Note Type
                                            </label>
                                            <div className="flex items-center space-x-2">
                                                <span className="text-2xl">{getNoteTypeInfo(selectedNote.NotesType).icon}</span>
                                                <span className="text-sm font-medium text-slate-900 dark:text-white">
                                                    {selectedNote.NotesType}
                                                </span>
                                            </div>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide mb-1">
                                                Status
                                            </label>
                                            <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${getStatusBadge(selectedNote.NoteStatus)}`}>
                                                {selectedNote.NoteStatus === 'CRITICAL' && <AlertCircle className="w-3 h-3 mr-1" />}
                                                {selectedNote.NoteStatus || '—'}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Contact Person */}
                                    <div>
                                        <label className="block text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide mb-1">
                                            Contact Person
                                        </label>
                                        <div className="flex items-center space-x-2 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-lg">
                                            <User className="w-4 h-4 text-slate-400" />
                                            <span className="text-sm text-slate-900 dark:text-white">
                                                {selectedNote.ContactPerson || 'Not specified'}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Notes Content */}
                                    <div>
                                        <label className="block text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide mb-1">
                                            Notes
                                        </label>
                                        <div className="p-3 bg-slate-50 dark:bg-slate-800/50 rounded-lg">
                                            <p className="text-sm text-slate-900 dark:text-white whitespace-pre-wrap">
                                                {selectedNote.Notes}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Dates and Times */}
                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide mb-1">
                                                <div className="flex items-center">
                                                    <Calendar className="w-3 h-3 mr-1" />
                                                    Created Date
                                                </div>
                                            </label>
                                            <div className="space-y-1">
                                                <p className="text-sm font-medium text-slate-900 dark:text-white">
                                                    {moment(selectedNote.CreatedOn).format('MMMM DD, YYYY')}
                                                </p>
                                                <p className="text-xs text-slate-500 dark:text-slate-400">
                                                    {moment(selectedNote.CreatedOn).format('hh:mm A')}
                                                </p>
                                            </div>
                                        </div>

                                        <div>
                                            <label className="block text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide mb-1">
                                                <div className="flex items-center">
                                                    <Clock className="w-3 h-3 mr-1" />
                                                    Reminder Date
                                                </div>
                                            </label>
                                            {selectedNote.SetReminder ? (
                                                <div className="space-y-1">
                                                    <p className="text-sm font-medium text-slate-900 dark:text-white">
                                                        {moment(selectedNote.SetReminder).format('MMMM DD, YYYY')}
                                                    </p>
                                                    <p className="text-xs text-slate-500 dark:text-slate-400">
                                                        {moment(selectedNote.SetReminder).format('hh:mm A')}
                                                    </p>
                                                </div>
                                            ) : (
                                                <p className="text-sm text-slate-400 dark:text-slate-500 italic">No reminder set</p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Created By */}
                                    <div>
                                        <label className="block text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide mb-1">
                                            <div className="flex items-center">
                                                <User className="w-3 h-3 mr-1" />
                                                Created By
                                            </div>
                                        </label>
                                        <p className="text-sm text-slate-900 dark:text-white">
                                            {selectedNote.CreatedBy}
                                        </p>
                                    </div>

                                    {/* Read Status */}
                                    <div>
                                        <label className="block text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide mb-1">
                                            <div className="flex items-center">
                                                <CheckCircle className="w-3 h-3 mr-1" />
                                                Read Status
                                            </div>
                                        </label>
                                        {selectedNote.ReadBy ? (
                                            <div className="space-y-1">
                                                <p className="text-sm text-slate-900 dark:text-white">
                                                    Read by: {selectedNote.ReadBy}
                                                </p>
                                                <p className="text-xs text-slate-500 dark:text-slate-400">
                                                    On: {moment(selectedNote.ReadOn).format('MMMM DD, YYYY hh:mm A')}
                                                </p>
                                            </div>
                                        ) : (
                                            <div className="flex items-center">
                                                <span className="px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100 rounded-full">
                                                    Unread
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Modal footer */}
                            <div className="px-6 py-4 border-t border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/50">
                                <div className="flex justify-end space-x-3">
                                    <button
                                        onClick={_closeModal}
                                        className="px-4 py-2 text-sm font-medium text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors"
                                    >
                                        Close
                                    </button>
                                    <button
                                        onClick={() => {
                                            _deleteNote(selectedNote?.BookingNotesId);
                                            _closeModal();
                                        }}
                                        className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors flex items-center"
                                    >
                                        <Trash2 className="w-4 h-4 mr-2" />
                                        Delete Note
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default UploadNotes;